export const BillingSectionDivider = () => (
  <div className="border-primary mb-6 border-b pb-6" />
);
